import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import classNames from 'classnames';
import get from 'lodash/get';

import styles from './style.scss';


class TagList extends React.Component {
  getLetterBlock(currentName, items, currentIndex) {
    const firstLetter = currentName.charAt(0).toUpperCase();
    if (currentIndex === 0) {
      return (
        <li className={classNames(styles.tag, 'jest-initial-letter-alphabetical-filtering')}>
          <span className={styles.letter}>
            {firstLetter}
          </span>
        </li>
      );
    }
    const lastFirstLetter = get(items, `[${currentIndex - 1}].name`, firstLetter).charAt(0).toUpperCase();
    if (firstLetter !== lastFirstLetter) {
      return (
        <li className={classNames(styles.tag, styles.tagInsideText, 'jest-initial-letter-alphabetical-filtering')}>
          <span className={styles.letter}>
            {firstLetter}
          </span>
        </li>
      );
    }
    else {
      return null;
    }
  };

  render() {
    const { tags, orderBy } = this.props;
    if (!tags) {
      return null;
    };

    return (
      <ul className={styles.tagLabelList}>
        {/* Заголовок с указателем буквы */}
        {tags.map((item, i) => {
          if (!item) {
            return (
              <li className={styles.tagEmpty} key={i}>
                <span className={styles.nameEmpty} />
                <span className={styles.counterEmpty} />
              </li>
            );
          }
          const { name, active_book_count: activeBookCount, slug } = item;
          const nameWithCapitalLetter = name.charAt(0).toUpperCase() + name.slice(1);
          return (
            <React.Fragment>
              {orderBy === 'asc' && this.getLetterBlock(name, tags, i)}
              <li className={styles.tag} key={slug}>
                <Link to={`/tags/${slug}/`} className={classNames(styles.name, 'link')}>
                  {nameWithCapitalLetter}
                </Link>
                <span className={styles.counter}>
                  {activeBookCount}
                </span>
              </li>
            </React.Fragment>
          );
        })}
      </ul>
    );
  }
};

TagList.propTypes = {
  tags: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
      slug: PropTypes.string,
      active_book_count: PropTypes.number,
    }),
  ),
};

export default TagList;
